import { OptionDefinition } from "@amzn/awsui-components-react/polaris/internal/components/option/interfaces";
import { LegalContactsPolarisFactory } from "./polaris/legal-contacts-polaris-factory";
import {
    ColumnDisplayPreference,
    DisplayConfiguration,
    LegalContact,
    WhosMyLawyerContent
} from "@amzn/ask-legal-domain";
import { CollectionPreferencesProps, TableProps } from "@amzn/awsui-components-react";

export namespace WhosMyLawyerFactory {
    export const toOptionDefinition = (id: string, whosMyLawyerContent?: WhosMyLawyerContent) => {
        const definition = getSortSelectOptions(whosMyLawyerContent).find(x => x.value === id);
        if (!definition) {
            return toOptionDefinition("legalContactUser.name", whosMyLawyerContent);
        }
        return definition;
    };

    export function getSortSelectOptions(whosMyLawyerContent?: WhosMyLawyerContent): OptionDefinition[] {
        return LegalContactsPolarisFactory.Table.toColumnDefinition(whosMyLawyerContent).filter(y => y.sortingField).map(x => ({
            label: x.header,
            value: x.sortingField
        }));
    }

    export function getSortingStateFromContent(content: WhosMyLawyerContent): TableProps.SortingState<LegalContact.Record> {
        if (!content.defaultConfiguration.sorting) {
            return LegalContactsPolarisFactory.DEFAULT_SORTING_STATE;
        }
        return {
            sortingColumn: LegalContactsPolarisFactory.Table.getSortingColumnById(content.defaultConfiguration.sorting.field, content),
            isDescending: content.defaultConfiguration.sorting.order === "DESC"
        };
    }

    export function toPreferencesFromDisplayConfiguration(
        configuration: DisplayConfiguration,
        content?: WhosMyLawyerContent
    ): CollectionPreferencesProps.Preferences<LegalContact.Record> {
        if (!configuration) return LegalContactsPolarisFactory.DEFAULT_PREFERENCES;
        // For backward compatibility, support existing user preferences
        const contentDisplay = configuration.columnDisplay?.map(col => {
            if (col.id === "legalScope") {
                return { ...col, id: "legalScopes" };
            }
            if (col.id === "legalTeam") {
                return { ...col, id: "legalTeams" };
            }
            if (col.id === "legalSubTeam") {
                return { ...col, id: "legalSubTeams" };
            }
            return col;
        }) || LegalContactsPolarisFactory.Table.getDefaultColumnDisplay(content);

        return {
            pageSize: configuration.pageSize || LegalContactsPolarisFactory.DEFAULT_PREFERENCES.pageSize,
            contentDisplay: contentDisplay,
            stripedRows: configuration.stripedRows || LegalContactsPolarisFactory.DEFAULT_PREFERENCES.stripedRows,
        };
    }

    export function toDisplayConfigurationFromPreferences(
        prefs: CollectionPreferencesProps.Preferences<LegalContact.Record>,
        configuration?: DisplayConfiguration
    ): DisplayConfiguration {
        return {
            ...configuration,
            pageSize: prefs.pageSize,
            columnDisplay: prefs.contentDisplay as ColumnDisplayPreference[],
            stripedRows: prefs.stripedRows
        };
    }
}